import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "statistics" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row mb-4" }
const _hoisted_4 = { class: "col-12 col-sm-6" }
const _hoisted_5 = { class: "col-12 col-sm-6" }
const _hoisted_6 = { class: "row content" }
const _hoisted_7 = { class: "col-12 col-sm-5" }
const _hoisted_8 = { class: "label label-ul" }
const _hoisted_9 = { class: "statistic-list" }
const _hoisted_10 = { class: "col-12 col-sm-3" }
const _hoisted_11 = { class: "label label-ul" }
const _hoisted_12 = { class: "label label-ul" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col results mb-4" }
const _hoisted_15 = { class: "button-bulletin_name_div" }
const _hoisted_16 = { class: "row diagram" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "text diagram__title" }
const _hoisted_19 = { class: "diagram__tabs tabs mb-4" }
const _hoisted_20 = { class: "bulletin-name" }
const _hoisted_21 = { class: "diagram__content" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "text diagram__text" }, null, -1)
const _hoisted_23 = { class: "chart" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "diagram__content" }
const _hoisted_27 = {
  class: "table statistics__table",
  cellpadding: "4"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("th", null, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_router_link = _resolveComponent("router-link")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_line_chart = _resolveComponent("line-chart")
  const _component_main_footer = _resolveComponent("main-footer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/statistics",
              class: "button statistics__button statistics__button--active button--primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('main.dynamic')), 1 /* TEXT */)
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/summary-table",
              class: "button statistics__button button--primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('main.summary')), 1 /* TEXT */)
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("label", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t('main.selectOrInput')) + " ", 1 /* TEXT */),
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "input",
                onKeyup: _cache[1] || (_cache[1] = (...args) => (_ctx.searchBulletinTimer(...args))),
                onFocus: _cache[2] || (_cache[2] = (...args) => (_ctx.searchBulletinTimer(...args))),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.data.search = $event)),
                placeholder: _ctx.inputPlaceBulletinName
              }, null, 40, ["placeholder"]), [
                [_vModelText, _ctx.data.search]
              ]),
              _createVNode(_component_svg_icon, { name: "triangle-down" })
            ]),
            _withDirectives(_createVNode("ul", _hoisted_9, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletins, (bulletin) => {
                return (_openBlock(), _createBlock("li", {
                  key: bulletin.id,
                  onClick: $event => (_ctx.clickBulletinById(bulletin.id, bulletin.name))
                }, _toDisplayString(bulletin.name), 9, ["onClick"]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512), [
              [_vShow, _ctx.changeactive]
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("label", _hoisted_11, [
              _createTextVNode(_toDisplayString(_ctx.$t('app.selectPeriod')) + " ", 1 /* TEXT */),
              _createVNode("label", _hoisted_12, [
                _withDirectives(_createVNode("select", {
                  id: "select-period",
                  onChange: _cache[4] || (_cache[4] = $event => (_ctx.showValuesByBulletin())),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.bulletinDate = $event)),
                  class: "custom-select"
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinPeriod, (period, index) => {
                    return (_openBlock(), _createBlock("option", {
                      key: index,
                      value: index
                    }, _toDisplayString(period.from_date) + " | " + _toDisplayString(period.to_date), 9, ["value"]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createVNode(_component_svg_icon, { name: "calendar" })
                ], 544), [
                  [_vModelSelect, _ctx.bulletinDate]
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinNameButton, (bulletin, index) => {
              return (_openBlock(), _createBlock("button", {
                key: index,
                class: "button-bulletin button-bulletin_name"
              }, [
                _createVNode("div", _hoisted_15, _toDisplayString(bulletin.name), 1),
                _createVNode(_component_svg_icon, {
                  name: "dagger",
                  onClick: _cache[6] || (_cache[6] = $event => (_ctx.deleteBulletin()))
                })
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinAttributesMap, (bulletinAttribute) => {
              return (_openBlock(), _createBlock("button", {
                key: bulletinAttribute.id,
                class: "button-bulletin button-bulletin_attribute"
              }, [
                _createTextVNode(_toDisplayString(bulletinAttribute.name) + " ", 1 /* TEXT */),
                _createVNode(_component_svg_icon, {
                  name: "dagger",
                  onClick: $event => (_ctx.deleteAttributes(bulletinAttribute.id))
                }, null, 8, ["onClick"])
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinLocationsMap, (bulletinLocation) => {
              return (_openBlock(), _createBlock("button", {
                key: bulletinLocation.id,
                class: "button-bulletin button-bulletin_location"
              }, [
                _createTextVNode(_toDisplayString(bulletinLocation.name) + " ", 1 /* TEXT */),
                _createVNode(_component_svg_icon, {
                  name: "dagger",
                  onClick: $event => (_ctx.deletelocations(bulletinLocation.id))
                }, null, 8, ["onClick"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('main.selectTypeDiagramm')), 1),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", {
                class: "tabs__item tabs__item--active",
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.setChart('bar')))
              }, [
                _createVNode(_component_svg_icon, { name: "bar-chart-activ" })
              ]),
              _createVNode("div", {
                class: "tabs__item",
                onClick: _cache[8] || (_cache[8] = $event => (_ctx.setChart('line')))
              }, [
                _createVNode(_component_svg_icon, { name: "line-chart-activ" })
              ]),
              _createVNode("div", {
                class: "tabs__item",
                onClick: _cache[9] || (_cache[9] = $event => (_ctx.setChart('polarArea')))
              }, [
                _createVNode(_component_svg_icon, { name: "multiaxis-chart-activ" })
              ]),
              _createVNode("div", {
                class: "tabs__item",
                onClick: _cache[10] || (_cache[10] = $event => (_ctx.setChart('pie')))
              }, [
                _createVNode(_component_svg_icon, { name: "pie-chart-activ" })
              ]),
              _createVNode("div", {
                class: "tabs__item",
                onClick: _cache[11] || (_cache[11] = $event => (_ctx.setChart('doughnut')))
              }, [
                _createVNode(_component_svg_icon, { name: "donught-chart-activ" })
              ])
            ]),
            _createVNode("h2", _hoisted_20, _toDisplayString(_ctx.graphics.name), 1),
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", _hoisted_23, [
                _createVNode(_component_line_chart, {
                  type: _ctx.graphics.chart,
                  data: {
                  labels: _ctx.graphics.labels,
                  datasets: _ctx.dataValues
                },
                  options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  scales: {
                    yAxes: [
                      {
                        ticks: { beginAtZero: true }
                      }
                    ]
                  }
                }
                }, null, 8, ["type", "data"])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode("table", _hoisted_27, [
                _createVNode("thead", null, [
                  _createVNode("tr", null, [
                    _hoisted_28,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinAttributesMap, (bulletinAttribute) => {
                      return (_openBlock(), _createBlock("th", {
                        key: bulletinAttribute.id
                      }, _toDisplayString(bulletinAttribute.name), 1))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bullettinTable, (Table) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: Table.id
                    }, [
                      _createVNode("th", null, _toDisplayString(Table.name), 1),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(Table.values, (lv) => {
                        return (_openBlock(), _createBlock("td", {
                          key: lv.id
                        }, _toDisplayString(lv.value), 1))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_main_footer)
  ], 64 /* STABLE_FRAGMENT */))
}